<form [formGroup]="form" class="cadastro-form" (submit)="confirmarCadastro($event)">
  <mat-form-field  class="form-field fullwidth" [ngClass]="{'new-password': showValidation}"  appearance="outline">
    <mat-label>Nova senha</mat-label>
    <input 
      matInput 
      name="inputSenha"
      formControlName="senha"
      type="password"
      placeholder="Nova senha" 
      autocomplete="off"
      minlength="8"
      maxlength="18"
      tabindex="2"
      (focus)="showValidation = true"
      [type]="showNewPassword ? 'text' : 'password'">
      <button mat-icon-button matSuffix type="button" (click)="showNewPassword = !showNewPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showNewPassword">
        <mat-icon class="suffix-icon" matSuffix>{{showNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
   </mat-form-field>
    <div *ngIf="showValidation" class="errors-container">
      <span>
        <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('minlength').color">
          {{getIconByErrorStatus('minlength').icon}}
        </mat-icon> Mínimo 8 dígitos
      </span>
      <span>
        <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasNumber').color">
          {{getIconByErrorStatus('hasNumber').icon}}
        </mat-icon> Pelo menos 1 número (0-9)
      </span>
      <span>
        <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasSpecialCharacters').color">
          {{getIconByErrorStatus('hasSpecialCharacters').icon}}
        </mat-icon> Pelo menos 1 caractere especial (&#64;, #, !)
      </span>
      <span>
        <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasCapitalCase').color">
          {{getIconByErrorStatus('hasCapitalCase').icon}}
        </mat-icon> Pelo menos uma letra maiúscula (A-Z)
      </span>
      <span>
        <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasSmallCase').color">
          {{getIconByErrorStatus('hasSmallCase').icon}}
        </mat-icon> Pelo menos uma letra minúscula (a-z)
      </span>
    </div>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="form.get('confirmarSenha').touched && (form.get('confirmarSenha')?.errors || form.hasError('passwordsDoNotMatch'))">
    <mat-label>Confirme a nova senha</mat-label>
    <input 
      matInput 
      name="inputConfirmarSenha"
      formControlName="confirmarSenha"
      [errorStateMatcher]="matcher"
      type="password"
      placeholder="Confirme a nova senha" 
      autocomplete="off"
      required
      [type]="showConfirmNewPassword ? 'text' : 'password'">
      <button mat-icon-button matSuffix type="button" (click)="showConfirmNewPassword = !showConfirmNewPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showConfirmNewPassword">
        <mat-icon class="suffix-icon" matSuffix>{{showConfirmNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    <mat-error class="error" *ngIf="form.get('confirmarSenha').touched && form.get('confirmarSenha').hasError('required')">
      <mat-icon class="material-symbols-outlined  mat-icon-error">error</mat-icon>
      Este campo é obrigatório!
    </mat-error>
    <mat-error class="error" *ngIf="form.hasError('passwordsDoNotMatch')">
      <mat-icon class="material-symbols-outlined  mat-icon-error">error</mat-icon>
      Deve ser igual à nova senha 
    </mat-error>
  </mat-form-field>

  <div  class="otp-container">
    <p class="hint">
      Por favor digite o código que enviamos para <strong>o celular ou e-mail cadastrado:</strong>
    </p>

    <div class="otp-input">
      <div class="otp-form-field">
        <ng-otp-input (onInputChange)="onOtpInputChange($event)" [config]="{
            length: 6, 
            allowNumbersOnly: false, 
            inputClass: confirmTokenError ? 'otp-error' : 'otp', 
            containerClass: 'containerClass'
          }">
        </ng-otp-input>
        <mat-error *ngIf="confirmTokenError">
          <mat-icon class="material-symbols-outlined  mat-icon-error">error</mat-icon> 
          Código incorreto.
        </mat-error>
      </div>
      <button [disabled]="form.invalid" enterkeyhint="send"  type="submit" mat-flat-button color="primary">
        <mat-icon class="spinner" *ngIf="loading">
          <mat-spinner diameter="20">
          </mat-spinner>
        </mat-icon>
        <span *ngIf="!loading">Verificar</span>          
      </button>

      <div *ngIf="!disableResend" class="send-token-actions">
        <button 
          mat-flat-button 
          color="primary" 
          class="send-btn"
          type="button"
          enterkeyhint="send"
          (click)="handleResendToken()"
          [disabled]="timerInProgress || loadingSendToken">
          <ng-container *ngIf="!loadingSendToken">
            Reenviar código 
            <mat-icon class="material-symbols-outlined">send</mat-icon>
          </ng-container>
          <mat-icon class="spinner" *ngIf="loadingSendToken">
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
        </button>
  
        <span *ngIf="timerInProgress" class="link-btn">
          Não recebi o código.
          <span *ngIf="timerInProgress"><strong>{{secondTicks}}s</strong></span>
        </span>
      </div>

      <button class="link-button" type="button" (click)="handleGoBack()" >
        Voltar
      </button>
    </div>
  </div>
</form>